import { render } from "./PerformerCard.vue?vue&type=template&id=02081e50&ts=true"
import script from "./PerformerCard.vue?vue&type=script&lang=ts"
export * from "./PerformerCard.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__